import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "hc_cookie_consent";

export function hasCookieConsent() {
  return localStorage.getItem(KEY) === "accepted";
}

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4 animate-in-up"
    >
      <div className="max-w-4xl mx-auto bg-slate-900 text-white rounded-xl shadow-2xl border border-slate-700 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <span className="w-9 h-9 rounded-lg bg-emerald-500/15 text-emerald-400 flex items-center justify-center shrink-0">
            <Cookie size={18} />
          </span>
          <p className="text-[13px] leading-relaxed text-slate-300">
            We use essential cookies to keep you signed in and run HaulCheck. With your consent we'd also
            use a small number of non-essential cookies to improve the service. See our{" "}
            <Link to="/privacy" className="text-emerald-400 font-semibold underline hover:text-emerald-300">Privacy Policy</Link>.
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            data-testid="cookie-reject-button"
            onClick={() => choose("rejected")}
            className="px-4 py-2 rounded-lg text-sm font-semibold text-slate-200 border border-slate-600 hover:bg-slate-800 transition-colors"
          >
            Essential only
          </button>
          <button
            data-testid="cookie-accept-button"
            onClick={() => choose("accepted")}
            className="px-4 py-2 rounded-lg text-sm font-bold bg-white text-slate-900 hover:bg-slate-100 transition-colors"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
